import React, { Component } from 'react'
import { Card, Row, Col, PageHeader, Button } from 'antd'
import Filters, { FilterItem, Types } from '../../components/Filters'
import { ShelterConsumer, ShelterProvider } from '../../context/ShelterContext'
import { QuestionGroupProvider } from '../../context/QuestionGroupContext'
import { LanguageProvider } from '../../context/LanguageContext'
import debounce from 'lodash.debounce'
import { CreditsProvider, CreditsConsumer } from 'context/CreditsContext'
import CreditsList from 'components/CreditsList'
import CreditsForm from 'components/Forms/Credits'
import { Link } from 'react-router-dom'

export default class Credits extends Component {
   ref:any

  private questionDispatchOptions = {
    search: {
    },
    options: {
      sort: []
    }
  } as const


  renderAdd = () => {
    const { permissions }: any = this.props
    if (!permissions.create) return null

    return (
      <Link to="credits/add">
        <Button type="primary" shape="round">
          Create new credit
        </Button>
      </Link>
    )
  }

  componentDidMount(): void {
    this.ref =  React.createRef();
  }
  render() {
    const { permissions, history, match: { params: { creditUuid } } }: any = this.props

    return (
      <CreditsProvider>
        <QuestionGroupProvider>
          <LanguageProvider>
            <ShelterProvider>
            <ShelterConsumer>
            {({ shelters, requestShelterList }) => (
              <CreditsConsumer>
                {(creditsContext) => {

                  const loadSheltersDispatch = (args: any = {}) =>
                    requestShelterList({
                      search: {
                        ...args,
                        organization_branches: {
                          with: true,
                        },
                      },
                      options: {
                        limit:-1,
                        sort: ["-organization_branches.name"],
                        _force_ids: true,
                      },
                    });

                  const delayedSearch = debounce((v) => {
                    if (v) {
                      loadSheltersDispatch({ name: { ilike: `%${v}%` } });
                    }
                  }, 500);

                  const sheltersToFilter = shelters?.map((v) => {
                    return {
                      value: v.id,
                      text: v.name,
                    };
                  });

                  const sheltersToAdd = shelters?.map((v) => {
                    return {
                      value: v.uuid,
                      label: v.name,
                    };
                  });

                  /*const SKIPPED;
                      const FORECAST;
                      const TRANSFERRED;
                      const PAID;
                      const UNPAID;
                      const SETTLED;
                      const COVERAGE;
                      const CREDIT;*/

                    // const invoicesStatus = [
                    //   'UNPAID',
                    //   'SKIPPED',
                    //   'FORECAST',
                    //   'TRANSFERRED',
                    //   'PAID',
                    //   'SETTLED',
                    //   'COVERAGE',
                    //   'CREDIT',
                    // ]

                    // const groupsToFilter = invoicesStatus.map(invoice => {
                    //   return {
                    //     value: invoice,
                    //     text: invoice
                    //   }
                    // })

                    if (creditUuid) {
                      let addon: any = {
                        data: creditsContext.credits,
                        permissions: permissions
                      }
                      if (creditUuid !== 'add') {
                        addon = {
                          ...addon,
                          uuid: creditUuid
                        }
                      }
        
                      return (
                        <Card>
                          <PageHeader title={creditUuid === 'add' ? 'New Credit' : 'Edit Credit'} onBack={() => history.goBack()}>
                            <CreditsForm
                              {...addon}
        
                              loading={creditsContext.fetching}
                              error={creditsContext.error}
                              history={history}
        
                              loadCredits={creditsContext.requestCreditsFind}
                              dispatchCreate={async (payload: any) => {
                                await creditsContext.requestCreditsCreate(payload)
                                history.push('/financial/credits')
                              }}
                              sheltersToFilter={sheltersToAdd}
                              loadSheltersDispatch={loadSheltersDispatch}
                              dispatchUpdate={null}
                            />
                          </PageHeader>
                        </Card>
                      )
                    }
                      /*Filters:
Shelter
is_active: true|false*/
                    return (
                      <>
                        <Card title="Filters" style={{marginBottom: 25}}>
                          <Filters ref={this.ref} size="medium" loading={creditsContext.fetching} history={history} defaultSubmitOptions={this.questionDispatchOptions} submitDispatch={creditsContext.requestCreditsList} >
                            {({ values, handleFilterChange }: any) => (
                              <Row gutter={9} style={{width: '100%'}}>

                                <Col xs={24} md={9}>
                                  <FilterItem
                                    name="shelter_id"
                                    type={Types.SELECT}
                                    placeholder="Shelter"
                                    data={sheltersToFilter}
                                    value={values["shelter_id"]}
                                    size="medium"
                                    options={{
                                      select: {
                                        allowClear: true,
                                        showSearch: true,
                                        onDropdownVisibleChange: (open) => {
                                          if (open) {
                                            loadSheltersDispatch();
                                          }
                                        },
                                        onSearch: async (v) => {
                                          delayedSearch(v);
                                        },
                                      },
                                    }}
                                    onChange={handleFilterChange}
                                  />
                                </Col>
                                <Col xs={24} md={9}>
                                  <FilterItem
                                    name="is_active"
                                    type={Types.SELECT}
                                    placeholder="Is Active"
                                    value={values["is_active"]}
                                    data={[{
                                      value: true,
                                      text: 'Active'
                                    }, {
                                      value: false,
                                      text: 'Inactive'
                                    }]}
                                    onChange={(v) => {
                                      console.log(v)
                                      handleFilterChange(v)
                                    }}
                                  />
                                </Col>
                              </Row>
                            )}
                          </Filters>
                        </Card>
                        <Card title="List of Credits" extra={this.renderAdd()}>
                          <CreditsList
                            loading={creditsContext.fetching}
                            permissions={permissions} 
                            history={history}
                            credits={creditsContext.credits}
                            pagination={creditsContext.pagination}
                            defaultSubmitOptions={creditsContext.filters}
                            loadCredits={creditsContext.requestCreditsList}
                          />
                        </Card>
                      </>
                    )
                }}
              </CreditsConsumer>
            )}
            </ShelterConsumer>
            </ShelterProvider>
          </LanguageProvider>
        </QuestionGroupProvider>
      </CreditsProvider>
    )
  }
}
